import { render, staticRenderFns } from "./JobRevise.vue?vue&type=template&id=d784127a&"
import script from "./JobRevise.vue?vue&type=script&lang=js&"
export * from "./JobRevise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports